export const emailSchema = {
    type: 'object',
    properties: {
        header: {
            type: 'object',
            properties: {
                bcitilogo: {
                    type: 'object',
                    properties: {
                        style: { type: 'string' },
                        alt: { type: 'string' },
                        url: { type: 'string' },
                        height: { type: 'string' },
                    },
                },
                villelogo: {
                    type: 'object',
                    properties: {
                        style: { type: 'string' },
                        alt: { type: 'string' },
                        url: { type: 'string' },
                        height: { type: 'string' },
                    },
                },
            },
        },
        footer: {
            type: 'object',
            properties: {
                block1: { type: 'string' },
                block2: { type: 'string' },
                block3: {
                    type: 'object',
                    properties: {
                        label: { type: 'string' },
                        url: { type: 'string' },
                    },
                },
                block4: { type: 'string' },
                block5: {
                    type: 'object',
                    properties: {
                        label: { type: 'string' },
                        url: { type: 'string' },
                    },
                },
            },
        },
    },
};
